/**
 * Images live in `static/assets/` at the project root.
 * Parcel copies `static/` to the site root, so URLs are `/assets/...` in dev
 * and work with `--public-url ./` for static hosting.
 *
 * Optional smaller previews: run `npm run thumbs` — JPEGs under `./thumbs/` (basename + `.jpg`).
 */
export function publicAsset(filename) {
  const encoded = filename.split("/").map((segment) => encodeURIComponent(segment)).join("/");
  return `./assets/${encoded}`;
}

/** Preview JPEG in `static/thumbs/` — same basename as the asset, always `.jpg` (see `npm run thumbs`). */
export function publicThumb(filename) {
  const base = filename.replace(/\.[^./]+$/, "");
  const thumbName = `${base}.jpg`;
  const encoded = thumbName.split("/").map((segment) => encodeURIComponent(segment)).join("/");
  return `./thumbs/${encoded}`;
}
